/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuswertungAufgabe } from '../models/AuswertungAufgabe';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AuswertungAufgabenUebersichtService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Auswertung einer Aufgabe für eine bestimmte Kontaktaufnahme
   * Gibt die Auswertung einer Aufgabe für eine bestimmte Kontaktaufnahme zurück
   * @returns AuswertungAufgabe Die Auswertung der Aufgabe
   * @throws ApiError
   */
  public getAuswertungAufgabe({
    aufgabeId,
    kontaktaufnahmeId,
  }: {
    /**
     * ID der Aufgabe
     */
    aufgabeId: string,
    /**
     * ID der Kontaktaufnahme
     */
    kontaktaufnahmeId: string,
  }): CancelablePromise<AuswertungAufgabe> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/auswertung/aufgabe/{aufgabeId}/{kontaktaufnahmeId}',
      path: {
        'aufgabeId': aufgabeId,
        'kontaktaufnahmeId': kontaktaufnahmeId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
      },
    });
  }

}
